import { createDownloadsByLocationChart } from "./downloads_by_location_chart";
import { buildCsvString, triggerCsvDownload } from "../../shared/csv_download";
import { wireDatePicker } from "../../../../shared/date_picker";


document.addEventListener('alpine:init', () => {
  Alpine.data('PrefixDownloadsByLocation', () => ({
    chartApi: null,
    loading: false,
    lastTop: null,
    barChart: null,
    currentGroup: 'country',
    init() {
      const root = this.$el || document;
      const chartEl = root.querySelector('#world-map') || document.getElementById('world-map');
      const wrapper = root.closest('[data-location-chart-root]') || root;
      const apiUrl = (wrapper?.dataset?.apiUrl) || '/analytics/chart';

      this.chartApi = createDownloadsByLocationChart(chartEl, apiUrl);

      try {
        this.pickerApi = wireDatePicker({
          rootEl: this.$el || document,
          onChange: (payload) => {
            const from = (this.$el || document).querySelector('#location_from')?.value;
            const to = (this.$el || document).querySelector('#location_to')?.value;
            const gb = this.currentGroup || 'country';
            // Ensure map is visible and refreshed
            this.toggleMap();
            if (from && to) {
              this.loading = true;
              const mapPromise = this.chartApi.loadCustom(from, to, 'country');
              const tablePromise = this.chartApi.loadCustom(from, to, gb)
                .then((data) => { try { this.lastTop = data; this.populateTable(data); } catch (_) {} });
              Promise.all([mapPromise, tablePromise])
                .catch(e => console.error('downloads_by_location: custom load error', e))
                .finally(() => { this.loading = false; });
            }
            this.syncClearVisibility();
          },
          inputSelector: '#location-range',
          buttonSelector: '#__none__',
          hiddenFromSelector: '#location_from',
          hiddenToSelector: '#location_to',
          maxDate: 'today',
          activeClasses: { add: ['bg-quill-100'], remove: ['bg-white'] }
        });
        const input = (this.$el || document).querySelector('#location-range');
        const clearBtn = (this.$el || document).querySelector('#location-clear');
        const fromEl = (this.$el || document).querySelector('#location_from');
        const toEl = (this.$el || document).querySelector('#location_to');
        const groupBtns = Array.from((this.$el || document).querySelectorAll('.groupByButton') || []);
        // Initialize currentGroup from buttons (default to country)
        try {
          if (groupBtns.length) {
            const activeBtn = groupBtns.find(b => b.classList.contains('bg-quill-100'));
            this.currentGroup = (activeBtn && activeBtn.dataset && activeBtn.dataset.group) ? activeBtn.dataset.group : 'country';
          }
        } catch (_) { this.currentGroup = 'country'; }
        this.syncClearVisibility = () => {
          try { if (clearBtn) (input && input.value && input.value.trim()) ? clearBtn.classList.remove('hidden') : clearBtn.classList.add('hidden'); } catch (_) {}
        };
        if (input) { input.addEventListener('input', this.syncClearVisibility); input.addEventListener('change', this.syncClearVisibility); setTimeout(this.syncClearVisibility, 0); }
        if (clearBtn) {
          clearBtn.addEventListener('click', () => {
            try { if (input) input.value=''; if (fromEl) fromEl.value=''; if (toEl) toEl.value=''; } catch(_) {}
            this.syncClearVisibility();
            // Clear to preset and reload map + table
            this.loading = true;
            const gb = this.currentGroup || 'country';
            this.toggleMap();
            const mapPromise = this.chartApi.loadPreset(7, 'country');
            const tablePromise = this.chartApi.loadPreset(7, gb)
              .then((data) => { try { this.lastTop = data; this.populateTable(data); this.updateHeading(); } catch (_) {} });
            Promise.all([mapPromise, tablePromise])
              .catch(e => console.error('downloads_by_location: reset load error', e))
              .finally(() => { this.loading = false; });
          });
        }
        if (groupBtns && groupBtns.length) {
          const setActive = (sel) => {
            try {
              groupBtns.forEach(btn => {
                if (btn === sel) {
                  btn.classList.add('bg-quill-100');
                  btn.classList.remove('bg-white');
                } else {
                  btn.classList.remove('bg-quill-100');
                  btn.classList.add('bg-white');
                }
              });
            } catch (_) {}
          };
          groupBtns.forEach(btn => {
            btn.addEventListener('click', () => {
              try { this.currentGroup = (btn.dataset && btn.dataset.group) ? btn.dataset.group : 'country'; } catch (_) { this.currentGroup = 'country'; }
              setActive(btn);
              this.loading = true;
              const from = fromEl && fromEl.value;
              const to = toEl && toEl.value;
              this.toggleMap();
              const loadTable = (from && to)
                ? this.chartApi.loadCustom(from, to, this.currentGroup)
                : this.chartApi.loadPreset(7, this.currentGroup);
              const loadMap = (from && to)
                ? this.chartApi.loadCustom(from, to, 'country')
                : this.chartApi.loadPreset(7, 'country');
              const tablePromise = loadTable.then((data) => { try { this.lastTop = data; this.populateTable(data); this.updateHeading(); } catch (_) {} });
              Promise.all([loadMap, tablePromise])
                .catch(e => console.error('downloads_by_location: group button load error', e))
                .finally(() => { this.loading = false; });
            });
          });
        }
      } catch (_) {}

      this.loading = true;
      // Determine initial group from buttons, default to country
      try {
        const activeBtn = (this.$el || document).querySelector('.groupByButton.bg-quill-100');
        this.currentGroup = (activeBtn && activeBtn.dataset && activeBtn.dataset.group) ? activeBtn.dataset.group : 'country';
      } catch (_) { this.currentGroup = 'country'; }
      this.toggleMap();
      const mapPromise = this.chartApi.loadPreset(7, 'country');
      const tablePromise = this.chartApi.loadPreset(7, this.currentGroup)
        .then((data) => { try { this.lastTop = data; this.populateTable(data); this.updateHeading(); } catch (_) {} });
      Promise.all([mapPromise, tablePromise])
        .catch(e => console.error('downloads_by_location: initial load error', e))
        .finally(() => { this.loading = false; });

      window.addEventListener('turbo:before-cache', () => this.destroy());
      const dlBtn = root.querySelector('#prefix-location-csv');
      if (dlBtn) {
        dlBtn.addEventListener('click', async () => {
          try {
            let data = this.lastTop;
            if (!data) {
            const params = new URLSearchParams();
            params.append('chart_type', 'audience_downloads_by_location');
            try {
              const from = (this.$el || document).querySelector('#location_from')?.value;
              const to = (this.$el || document).querySelector('#location_to')?.value;
              if (from && to) {
                params.append('date_range', 'custom');
                params.append('start_date', from);
                params.append('end_date', to);
              } else {
                params.append('date_range', 'all_time');
              }
            } catch (_) { params.append('date_range', 'all_time'); }
            try {
              const gb = this.currentGroup || 'country';
              params.append('group_by', gb);
            } catch (_) {}
            const res = await fetch(`${apiUrl}?${params.toString()}`, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
              if (!res.ok) throw new Error(`location csv fetch failed ${res.status}`);
              const raw = await res.json();
              let labelsArr = null, seriesArr = null;
              if (raw && Array.isArray(raw.labels) && Array.isArray(raw.series)) {
                labelsArr = raw.labels; seriesArr = raw.series;
              } else if (raw && raw.chart_data && Array.isArray(raw.chart_data.labels) && Array.isArray(raw.chart_data.series)) {
                labelsArr = raw.chart_data.labels; seriesArr = raw.chart_data.series;
              }
              if (labelsArr && seriesArr) {
                const pairs = labelsArr.map((n, i) => [String(n||''), Number(seriesArr[i]||0)]).filter(p => p[0]);
                pairs.sort((a,b) => b[1]-a[1]);
                const denom = pairs.reduce((s,p) => s + (p[1]||0), 0) || 1;
                data = {
                  topLabels: pairs.map(p => p[0]),
                  topSeries: pairs.map(p => p[1]),
                  topPercents: pairs.map(p => Math.round((p[1]*100.0/denom)*100)/100)
                };
              } else {
                data = this.lastTop || {};
              }
            }
            const labels = data?.topLabels || [];
            const series = data?.topSeries || [];
            const percents = data?.topPercents || [];
            const rows = [];
            for (let i = 0; i < labels.length; i++) rows.push([`#${i+1}`, labels[i], Number(series[i]||0), `${Number(percents[i]||0)}%`]);
            const gb2 = this.currentGroup || 'country';
            const labelHeader = gb2 === 'city' ? 'City' : (gb2 === 'state_province' ? 'State/Province' : 'Country');
            const csv = buildCsvString(['Ranking',labelHeader,'Total Downloads','% Downloads'], rows);
            triggerCsvDownload(csv, 'downloads_by_location.csv');
          } catch (e) { console.error('location csv error', e); }
        });
      }
    },
    populateTable(data) {
      const tbody = (this.$el || document).querySelector('#prefix-location-table');
      if (!tbody) return;
      tbody.innerHTML = '';
      const labels = data?.topLabels || [];
      const series = data?.topSeries || [];
      const percents = data?.topPercents || [];
      for (let i = 0; i < labels.length; i++) {
        const rank = i + 1;
        const name = labels[i];
        const total = Number(series[i] || 0);
        const pct = Number(percents[i] || 0);
        tbody.insertAdjacentHTML('beforeend', `
          <tr class="h-12">
            <td class="px-6 py-3 whitespace-nowrap text-sm font-medium text-black">#${rank}</td>
            <td class="px-6 py-3 whitespace-nowrap text-sm font-medium text-black">${name}</td>
            <td class="px-6 py-3 whitespace-nowrap text-sm text-black text-right">${total}</td>
            <td class="px-6 py-3 whitespace-nowrap text-sm text-black text-right">${pct}%</td>
          </tr>
        `);
      }
    },
    updateHeading() {
      try {
        const gb = this.currentGroup || 'country';
        const th = (this.$el || document).querySelector('#prefix-location-heading-label');
        if (!th) return;
        if (gb === 'city') th.textContent = 'City';
        else if (gb === 'state_province') th.textContent = 'State/Province';
        else th.textContent = 'Country';
      } catch (_) {}
    },
    // Ensure map is visible and nudge redraw for proper sizing.
    toggleMap() {
      try {
        const mapEl = document.getElementById('world-map');
        if (!mapEl || !mapEl.parentElement) return;
        try { mapEl.parentElement.style.removeProperty('display'); } catch (_) {}
        // Force a resize/redraw after showing to fix tiny chart issues
        setTimeout(() => {
          try {
            const chartId = mapEl.id || 'world-map';
            const ck = (window.Chartkick && window.Chartkick.charts) ? window.Chartkick.charts[chartId] : null;
            if (ck && typeof ck.updateData === 'function') {
              const current = ck.getData && typeof ck.getData === 'function' ? ck.getData() : null;
              ck.updateData(current || ck.dataSource || {});
            }
          } catch(_) {}
          try { window.dispatchEvent(new Event('resize')); } catch(_) {}
        }, 0);
      } catch (e) { console.error('downloads_by_location: bar chart error', e); }
    },
    destroy() {
      try { this.chartApi && this.chartApi.destroy && this.chartApi.destroy(); } catch (_) {}
      this.chartApi = null;
      try { this.barChart && this.barChart.destroy && this.barChart.destroy(); } catch (_) {}
      this.barChart = null;
    }
  }));
});
